var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3753",
    "data-name": "Rectangle 3753",
    width: 24,
    height: 24,
    transform: "translate(60 179)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Merchant_Export",
    "data-name": "Merchant Export",
    transform: "translate(-60 -179)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9475",
    "data-name": "Group 9475",
    transform: "translate(63.339 182.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9474",
    "data-name": "Group 9474",
    transform: "translate(0.473 0.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11993",
    "data-name": "Path 11993",
    d: "M17.653,15.726v4.354A2.016,2.016,0,0,1,15.637,22.1H4.516A2.016,2.016,0,0,1,2.5,20.081V8.961A2.016,2.016,0,0,1,4.516,6.944h4.6",
    transform: "translate(-2.5 -5.777)",
    fill: "none",
    stroke: "#f5be03",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11994",
    "data-name": "Path 11994",
    d: "M41.1,2.7h5.761V8.462",
    transform: "translate(-30.489 -2.701)",
    fill: "none",
    stroke: "#f5be03",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1463",
    "data-name": "Line 1463",
    x1: 10.931,
    y2: 10.93,
    transform: "translate(4.46 0.929)",
    fill: "none",
    stroke: "#f5be03",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantExport);
export default __webpack_public_path__ + "static/media/MerchantExport.ad48486c1348529d44621d06f41ed25f.svg";
export { ForwardRef as ReactComponent };